import { render, staticRenderFns } from "./PersonalInfoCard.vue?vue&type=template&id=7c4d981a&scoped=true&"
import script from "./PersonalInfoCard.vue?vue&type=script&lang=js&"
export * from "./PersonalInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./PersonalInfoCard.vue?vue&type=style&index=0&id=7c4d981a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4d981a",
  null
  
)

export default component.exports